import {PossibleAges} from '../age-utils';
import {Dropdown} from './dropdown';

const AGE_CHILDREN_OPTIONS_FR: Dropdown<PossibleAges>[] = [
  {name: `Naissance à venir`, value: PossibleAges.BIRTH_TO_COME},
  {name: `0 à 12 mois`, value: PossibleAges.ZERO_TWELVE_MONTHS},
  {name: `1 an`, value: PossibleAges.ONE},
  {name: `2 ans`, value: PossibleAges.TWO},
  {name: `3 ans`, value: PossibleAges.THREE},
  {name: `4 ans`, value: PossibleAges.FOUR},
  {name: `5 ans`, value: PossibleAges.FIVE},
  {name: `6 ans`, value: PossibleAges.SIX},
  {name: `7 ans`, value: PossibleAges.SEVEN},
  {name: `8 ans`, value: PossibleAges.EIGHT},
  {name: `9 ans`, value: PossibleAges.NINE},
  {name: `10 ans`, value: PossibleAges.TEN},
  {name: `11 ans`, value: PossibleAges.ELEVEN},
  {name: `12 ans`, value: PossibleAges.TWELVE},
  {name: `13 ans`, value: PossibleAges.THIRTEEN},
  {name: `14 ans`, value: PossibleAges.FOURTEEN},
  {name: `15 ans`, value: PossibleAges.FIFTEEN},
  {name: `16 ans`, value: PossibleAges.SIXTEEN},
  {name: `17 ans`, value: PossibleAges.SEVENTEEN},
  {name: `18 ans`, value: PossibleAges.EIGHTEEN},
  {name: `19 ans`, value: PossibleAges.NINETEEN},
  {name: `20 ans`, value: PossibleAges.TWENTY},
  {name: `21 ans`, value: PossibleAges.TWENTY_ONE},
  {name: `22 ans`, value: PossibleAges.TWENTY_TWO},
  {name: `23 ans`, value: PossibleAges.TWENTY_THREE},
  {name: `24 ans`, value: PossibleAges.TWENTY_FOUR},
  {name: `25 ans et plus`, value: PossibleAges.TWENTY_FIVE_OR_MORE},
];

const AGE_CHILDREN_OPTIONS_EN: Dropdown<PossibleAges>[] = [
  {name: `Birth to come`, value: PossibleAges.BIRTH_TO_COME},
  {name: `0 to 12 months`, value: PossibleAges.ZERO_TWELVE_MONTHS},
  {name: `1 year old`, value: PossibleAges.ONE},
  {name: `2 years old`, value: PossibleAges.TWO},
  {name: `3 years old`, value: PossibleAges.THREE},
  {name: `4 years old`, value: PossibleAges.FOUR},
  {name: `5 years old`, value: PossibleAges.FIVE},
  {name: `6 years old`, value: PossibleAges.SIX},
  {name: `7 years old`, value: PossibleAges.SEVEN},
  {name: `8 years old`, value: PossibleAges.EIGHT},
  {name: `9 years old`, value: PossibleAges.NINE},
  {name: `10 years old`, value: PossibleAges.TEN},
  {name: `11 years old`, value: PossibleAges.ELEVEN},
  {name: `12 years old`, value: PossibleAges.TWELVE},
  {name: `13 years old`, value: PossibleAges.THIRTEEN},
  {name: `14 years old`, value: PossibleAges.FOURTEEN},
  {name: `15 years old`, value: PossibleAges.FIFTEEN},
  {name: `16 years old`, value: PossibleAges.SIXTEEN},
  {name: `17 years old`, value: PossibleAges.SEVENTEEN},
  {name: `18 years old`, value: PossibleAges.EIGHTEEN},
  {name: `19 years old`, value: PossibleAges.NINETEEN},
  {name: `20 years old`, value: PossibleAges.TWENTY},
  {name: `21 years old`, value: PossibleAges.TWENTY_ONE},
  {name: `22 years old`, value: PossibleAges.TWENTY_TWO},
  {name: `23 years old`, value: PossibleAges.TWENTY_THREE},
  {name: `24 years old`, value: PossibleAges.TWENTY_FOUR},
  {name: `25 years old or more`, value: PossibleAges.TWENTY_FIVE_OR_MORE},
];

export const AGE_CHILDREN_OPTIONS = {
  en: AGE_CHILDREN_OPTIONS_EN,
  fr: AGE_CHILDREN_OPTIONS_FR,
};
